<template>
    <a  v-if="href" :href="href" target="_blank">
        <el-button class="CustomBtn" :class="activeData.class? activeData.class:''" :round="activeData.type === 'round'" :disabled="disabled">{{ text }}</el-button>
    </a>
    <el-button v-else class="CustomBtn" :class="activeData.class? activeData.class:''" :round="activeData.type === 'round'" :disabled="disabled">{{ text }}</el-button>
</template>
<script>
export default {
    props: {
        type: {
            type: String,
            default: "default"
        },
        href: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        text: {
           type: String,
           default: "" 
        }
    },
    data() {
        return {
            activeData: {
                type: "round",
                class: ""
            },
            configData: {
                default: {
                    type: "round",
                    class: "default"
                },
                'default-reverse': {
                    type: "round",
                    class: "default reverse"
                }
            }
        }
    },
    beforeMount() {
        if(this.configData[this.type]) {
            this.activeData = this.configData[this.type]
        }
    }
}
</script>
<style lang="scss">
.el-button.CustomBtn {
    padding: 14px 48px !important;
    max-width: 100%;
    height: auto;
    font-size: 1rem;
    &.default {
        color: white;
        background-color: black;
        border: 0;
        &:hover {
            background-color: #3283c2;
            border-color: #3283c2;
        }
        &.reverse {
            color: black;
            background-color: transparent;
            &:hover {
                color: white;
                background-color: black;
            }
        }
    }
}
</style>